import DataGrid, { SelectColumn } from 'react-data-grid';
import NoRecords from 'components/ui/DataGrid/NoRecords';
import { useState } from 'react';

function BotReportEditColumns({ schema, onChange, report }) {
  const columns = [SelectColumn, { key: 'title', name: 'Name', width: 'auto' }];

  const data = Object.values(schema.properties || {});
  const keys = Object.keys(schema.properties || {});
  const [selectedRows, setSelectedRows] = useState(() => new Set(report.columns || []));

  const rowKeyGetter = row => {
    return keys[data.findIndex(item => item.title === row.title)];
  };

  const handleSelectedRowsChange = rows => {
    setSelectedRows(rows);
    onChange(Array.from(rows));
  };

  return (
    <DataGrid
      rowKeyGetter={rowKeyGetter}
      className="data-grid rdg-light fill-grid"
      columns={columns}
      defaultColumnOptions={{
        sortable: true,
        resizable: true,
      }}
      rows={data}
      rowName="row"
      rowHeight={60}
      selectedRows={selectedRows}
      onSelectedRowsChange={handleSelectedRowsChange}
      emptyRowsRenderer={NoRecords}
    />
  );
}

export default BotReportEditColumns;
